import { Users } from 'lucide-react';

/**
 * Shown while you are the only person in the room. Without it a solo tile
 * reads as "the other side's video is broken" rather than "they have not
 * arrived yet", and people leave a call that was about to start.
 */
export function WaitingForOthers({ otherPartyName }: { otherPartyName: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      // Solid rather than `glass`: a backdrop blur over live video re-blurs
      // every frame, which is expensive on phones and wedges headless Chrome.
      className="call-waiting bg-card/92 animate-in fade-in-0 slide-in-from-top-2 flex max-w-sm items-center gap-3 rounded-2xl border px-4 py-3 shadow-[var(--shadow-glass)] duration-300"
    >
      <span className="relative grid size-9 shrink-0 place-items-center">
        <span className="border-primary/30 absolute inset-0 animate-ping rounded-full border motion-reduce:animate-none" />
        <span className="border-primary/25 bg-primary/10 absolute inset-0 rounded-full border" />
        <Users className="text-primary size-4" />
      </span>
      <div className="min-w-0">
        <p className="text-sm leading-tight font-medium text-pretty">
          Waiting for {otherPartyName} to join
        </p>
        <p className="text-muted-foreground mt-0.5 text-xs text-pretty">
          Stay on this screen. The interview starts as soon as they connect.
        </p>
      </div>
    </div>
  );
}
